export enum UserRole {
  CITIZEN = 'citizen',
  CITY_MANAGER = 'city_manager',
  STATE_MANAGER = 'state_manager',
  FEDERAL_MANAGER = 'federal_manager',
}

export enum OccurrenceStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
}

export enum OccurrencePriority {
  URGENT = 'urgent',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export interface Category {
  id: string;
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  pin?: string;
  cityId: string;
  isActive: boolean;
}

export type UserType = 'admin' | 'manager' | 'priority' | 'citizen';

export const USER_TYPE_LABELS: Record<UserType, string> = {
  admin: 'Administrador',
  manager: 'Gestor',
  priority: 'Prioritário',
  citizen: 'Cidadão',
};

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  userType: UserType;
  cityId: string;
  isActive: boolean;
  cpf?: string;
  birthDate?: string;
  phone?: string;
  whatsapp?: string;
  verified?: boolean;
  groups?: { id: string; name: string }[];
  createdAt: string;
  updatedAt: string;
  cities?: CityLink[];
  activeCityId?: string;
  primaryCityId?: string;
}

export interface CityLink {
  cityId: string;
  cityName: string;
  state: string;
  userType: UserType;
  isActive: boolean;
}

export interface City {
  id: string;
  name: string;
  state: string;
  lat: number;
  lng: number;
  slug?: string;
  contratado: boolean;
  citizenRegistrationEnabled: boolean;
  isActive: boolean;
}

export interface Occurrence {
  id: string;
  description: string;
  categoryId: string;
  category?: Category;
  lat: number;
  lng: number;
  address?: string;
  status: OccurrenceStatus;
  priority: OccurrencePriority;
  citizenId: string;
  cityId: string;
  images: string[];
  assignedTo?: string;
  resolvedAt?: string;
  createdAt: string;
  updatedAt: string;
  citizen?: User;
  city?: City;
}

export interface Resolution {
  id: string;
  occurrenceId: string;
  resolutionImages: string[];
  lat: number;
  lng: number;
  resolvedBy: string;
  notes: string;
  createdAt: string;
}

export interface Notification {
  id: string;
  userId: string;
  title: string;
  message: string;
  type: 'info' | 'warning' | 'success' | 'error';
  isRead: boolean;
  occurrenceId?: string;
  createdAt: string;
}

export interface StatusHistory {
  id: string;
  occurrenceId: string;
  status: OccurrenceStatus;
  description?: string;
  changedBy: string;
  changedByUser?: { id: string; name: string };
  changedAt: string;
}

export interface AuthResponse {
  access_token: string;
  user: User;
}

export interface Stats {
  total: number;
  pending: number;
  inProgress: number;
  resolved: number;
}

export const STATUS_LABELS: Record<OccurrenceStatus, string> = {
  [OccurrenceStatus.PENDING]: 'Pendente',
  [OccurrenceStatus.IN_PROGRESS]: 'Em andamento',
  [OccurrenceStatus.RESOLVED]: 'Resolvido',
  [OccurrenceStatus.CANCELLED]: 'Cancelado',
  [OccurrenceStatus.REJECTED]: 'Rejeitado',
};

export const PRIORITY_LABELS: Record<OccurrencePriority, string> = {
  [OccurrencePriority.URGENT]: 'Urgente',
  [OccurrencePriority.HIGH]: 'Alta',
  [OccurrencePriority.MEDIUM]: 'Média',
  [OccurrencePriority.LOW]: 'Baixa',
};

export const PRIORITY_COLORS: Record<OccurrencePriority, string> = {
  [OccurrencePriority.URGENT]: '#dc2626',
  [OccurrencePriority.HIGH]: '#ea580c',
  [OccurrencePriority.MEDIUM]: '#ca8a04',
  [OccurrencePriority.LOW]: '#16a34a',
};